var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.text)?_c('div',{staticClass:"d-inline"},[_c('span',{staticClass:"text-muted small"},[_vm._v("смсок: "+_vm._s(_vm.sms)+" ("+_vm._s(_vm.symbols)+" симв.)")]),_vm._v(" "),_c('HelpPopover',{attrs:{"about":"Количество символов в смс"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }